(function () {
  if (typeof window.fetch !== 'function') return;

  var originalFetch = window.fetch;

  var CART_ENDPOINTS = {
    add: '/cart/add.js',
    get: '/cart.js',
    update: '/cart/update.js',
    change: '/cart/change.js',
    clear: '/cart/clear.js',
  };

  var cartCache = { data: null };
  var cartJsonFlight = null;
  var cacheValid = false;
  var mutationFlight = null;

  function getPathname(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input instanceof URL) url = input.href;
    else if (input && typeof input.url === 'string') url = input.url;
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (_) {
      return '';
    }
  }

  function matchEndpoint(input) {
    var pathname = getPathname(input);
    for (var key in CART_ENDPOINTS) {
      if (pathname === CART_ENDPOINTS[key]) return key;
    }
    return null;
  }

  function setCache(cart) {
    if (!cart || typeof cart !== 'object') return;
    cartCache.data = cart;
    cacheValid = true;
    document.dispatchEvent(
      new CustomEvent('cart:cache-updated', { detail: cart }),
    );
  }

  function invalidateCache() {
    cacheValid = false;
  }

  function handleToastErrors(response) {
    if (response.status === 429) {
      if (typeof window.toast === 'function') {
        window.toast(
          'Please refresh the page and complete the human verification process.',
        );
      }
      return;
    }
    response
      .clone()
      .json()
      .then(function (body) {
        if (body && body.status === 422 && body.message) {
          if (typeof window.toast === 'function') {
            window.toast(body.message);
          }
        }
      })
      .catch(function () {});
  }

  function fetchCartJson() {
    if (cartJsonFlight) return cartJsonFlight;
    cartJsonFlight = originalFetch
      .call(window, CART_ENDPOINTS.get + '?t=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET',
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setCache(cart);
        return cart;
      })
      .finally(function () {
        cartJsonFlight = null;
      });
    return cartJsonFlight;
  }

  function makeCartResponse(cart) {
    return new Response(JSON.stringify(cart), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  window.fetch = function (input, init) {
    var endpoint = matchEndpoint(input);

    if (endpoint === 'get') {
      // If a mutation is in flight, wait for it to finish then fetch fresh cart
      if (mutationFlight) {
        return mutationFlight.then(function () {
          if (cacheValid && cartCache.data) {
            return makeCartResponse(cartCache.data);
          }
          return fetchCartJson().then(function (cart) {
            return makeCartResponse(cart);
          });
        });
      }

      if (cartJsonFlight) {
        return cartJsonFlight.then(function (cart) {
          return makeCartResponse(cart);
        });
      }

      if (cacheValid && cartCache.data) {
        return Promise.resolve(makeCartResponse(cartCache.data));
      }

      var realFetchPromise = originalFetch.call(window, input, init);

      cartJsonFlight = realFetchPromise
        .then(function (response) {
          return response.clone().json();
        })
        .then(function (cart) {
          setCache(cart);
          return cart;
        })
        .catch(function () {
          return null;
        })
        .finally(function () {
          cartJsonFlight = null;
        });

      return realFetchPromise.then(function (response) {
        handleToastErrors(response);
        return response;
      });
    }

    if (endpoint === 'add') {
      invalidateCache();
      var addPromise = originalFetch
        .call(window, input, init)
        .then(function (response) {
          handleToastErrors(response);
          if (response.ok) {
            fetchCartJson();
          }
          return response;
        });
      mutationFlight = addPromise
        .catch(function () {})
        .finally(function () {
          mutationFlight = null;
        });
      return addPromise;
    }

    if (
      endpoint === 'update' ||
      endpoint === 'change' ||
      endpoint === 'clear'
    ) {
      invalidateCache();
      var mutPromise = originalFetch
        .call(window, input, init)
        .then(function (response) {
          handleToastErrors(response);
          if (response.ok) {
            fetchCartJson();
          }
          return response;
        });
      mutationFlight = mutPromise
        .catch(function () {})
        .finally(function () {
          mutationFlight = null;
        });
      return mutPromise;
    }

    return originalFetch.call(window, input, init);
  };

  window.__cartInterceptor = {
    getCache: function () {
      return cartCache.data;
    },
    refresh: fetchCartJson,
  };
})();
